import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { toaster } from 'baseui/toast';
import { updateProjectTypes } from '@gtintel/platform-api';
import { useAsyncOp } from '@gtintel/platform-utils';
export function SaveButton({
  updatedRows,
  onSave
}) {
  const [css] = useStyletron();
  const {
    isLoading,
    fn: save
  } = useAsyncOp(updateProjectTypes);
  const handleSave = () => {
    if (updatedRows.length) {
      const updatePayload = updatedRows.map(row => ({
        project: row.id,
        project_type: row.type
      }));
      save(updatePayload).then(() => {
        toaster.positive('Successfully updated project types!');
        updatedRows = [];
        onSave(true);
      }).catch(error => {
        toaster.negative('Error updating project types:', error);
      });
    }
  };
  return <>
      <div className={css({
      height: '20px'
    })} />
      <Button onClick={handleSave} disabled={updatedRows.length === 0} isLoading={isLoading}>
        Save
      </Button>
    </>;
}
export default SaveButton;